// (c) chaehongee. Confidential and proprietary.

import { useEffect } from 'react'

function isHomePath(pathname: string | undefined | null): boolean {
    const p = pathname ?? ''
    return p === '' || p === '/'
}

export function useResetOnHomeNavigation(): void {
    useEffect(() => {
        // Historically we reset global session state when navigating home.
        // With tabbed sessions, home navigation must not wipe open tabs/state.
        if (isHomePath(window.location?.pathname)) {
            try { localStorage.removeItem('session_id') } catch { }
        }

        function onPopState(): void {
            if (isHomePath(window.location?.pathname)) {
                try { localStorage.removeItem('session_id') } catch { }
            }
        }

        window.addEventListener('popstate', onPopState)
        return () => window.removeEventListener('popstate', onPopState)
    }, [])
}


